export const financialKpiGraphMock = {
  title: "Financial KPI's (YTD)",
  type: 'KPI',
  navigation: {
    type: 'GraphViews',
    nav: [
      {
        title: 'C',
        graph: {
          objectives: {
            total: 120,
            value: 67,
            title: 'Meeting the objectives',
          },
          formula: {
            total: 100,
            value: 92,
            title: 'ICL Formula with treshold',
          },
          data: [
            {
              title: 'Operating Income',
              columns: [30, 105, 72, 33],
            },
            {
              title: 'Sales',
              columns: [20, 400, 450, -50],
            },
            {
              title: 'CAPEX',
              columns: [20, 105, 80, 25],
            },
            {
              title: 'CF',
              columns: [10, 400, 450, 33],
            },
            {
              title: 'Sales',
              columns: [10, 400, 450, 33],
            },
            {
              title: 'Sales',
              columns: [10, 400, 450, -50],
            },
          ],
        },
      },
    ],
  },
};
